import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CommonChatService,
  ChatActionType,
  ChatMessageModel,
  ChatMessageRequest,
  PageModelChatMessageModel,
  PageKeyModelChatMessageModel
} from '../autogenerated';
import { PAGE, SIZE, REQUEST_OPTIONS } from '../constants';
import { RequestOptionsVoidType, RequestOptionsJsonType } from '../types';

@Injectable({ providedIn: 'root' })
export class CommonChatApiService {
  constructor(private apiService: CommonChatService) {}

  public actionChat(topicId: string, action: ChatActionType, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.chatActionGet(topicId, action, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteMessage(messageId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.chatMessageDelete(messageId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editMessage(messageId: string, body: ChatMessageRequest, customer?: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<ChatMessageModel> {
    return this.apiService.chatMessageEdit(messageId, body, customer, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getMessage(messageId: string, customer?: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<ChatMessageModel> {
    return this.apiService.chatMessageGet(messageId, customer, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getLastMessages(page: number = PAGE, size: number = SIZE, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageModelChatMessageModel> {
    return this.apiService.chatMessageLast(page, size, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getMessages(topicId: string, customer?: boolean, messageId?: string, nextSize?: number, prevSize?: number, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<PageKeyModelChatMessageModel> {
    return this.apiService.chatMessageList(topicId, customer, messageId, nextSize, prevSize, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public sendMessage(topicId: string, body: ChatMessageRequest, customer?: boolean, asBot?: boolean, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<ChatMessageModel> {
    return this.apiService.chatMessageSend(topicId, body, customer, asBot, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public viewChat(topicId: string, customer?: boolean, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.chatView(topicId, customer, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public viewAllChats(requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.chatViewAll(requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
